const DEFAULT_API_BASE = "https://boost.thejbschool.com";
const DEFAULT_ERP_BASE = "https://erp.thejbschool.com";

const trimTrailingSlash = (value) => String(value || "").replace(/\/+$/, "");

const resolveApiBase = () => {
  const envBase = trimTrailingSlash(process.env.REACT_APP_API_ADDRESS);
  if (envBase) {
    return envBase;
  }
  return DEFAULT_API_BASE;
};

export const API_BASE = resolveApiBase();
export const ERP_BASE = trimTrailingSlash(process.env.REACT_APP_ERP_URL) || DEFAULT_ERP_BASE;

let hasLoggedApiBase = false;

export const logApiBaseOnce = () => {
  if (hasLoggedApiBase) return;
  hasLoggedApiBase = true;
  if (process.env.REACT_APP_DEBUG_LOGS === "true") {
    // eslint-disable-next-line no-console
    console.info("[Booster] API base:", API_BASE);
  }
};

export const buildApiUrl = (path = "") => {
  const normalizedPath = String(path || "");
  if (!normalizedPath) return API_BASE;
  if (normalizedPath.startsWith("/")) return `${API_BASE}${normalizedPath}`;
  return `${API_BASE}/${normalizedPath}`;
};

export const buildErpUrl = (path = "") => {
  const normalizedPath = String(path || "");
  if (!normalizedPath) return ERP_BASE;
  if (normalizedPath.startsWith("/")) return `${ERP_BASE}${normalizedPath}`;
  return `${ERP_BASE}/${normalizedPath}`;
};
